import React from 'react';

interface LogoProps {
    logo_path: string;
}

class Logo extends React.Component<LogoProps> {
    render = () => {
        return (
            <img src={this.props.logo_path} width='100%' />
        )
    }
}

export default Logo;
